import { Button, Typography, useTheme } from '@ori-ui/mui';
import { generateSrcSet, getImageVariants } from '@ori/image-sizes-helper';
import useTestId from '@ori/testid-generator';
import { useMemo } from 'react';
import { LazyImage } from '../LazyImage';
import { CATEGORY_BOX } from './constants';
import { ImageWrapper, Root, ViewButtonWrapper } from './styles';
import { CategoryBoxSize } from './types';
import { getCategoryBoxImageHeight, getCategoryBoxWidth } from './utils';

/**
 * Returns link to a category. Contains image and name of the category. Displays button on hover.
 * Renders if `imageUrl`, `relativeUrl` and `title` have thruthy values.
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const CategoryBox = ({
  buttonText,
  className,
  description,
  imageUrl,
  relativeUrl,
  size = CategoryBoxSize.SMALL,
  title
}) => {
  const {
    getTestId
  } = useTestId();
  const theme = useTheme();
  const width = getCategoryBoxWidth({
    size
  });
  const height = getCategoryBoxImageHeight({
    size
  });
  const imagesVariants = useMemo(() => imageUrl ? generateSrcSet(getImageVariants({
    url: imageUrl,
    backgroundColor: theme.palette.grey[100],
    imageFormat: 'WebP',
    params: [{
      width: width.mobile,
      quality: 90
    }, {
      width: width.desktop,
      quality: 90
    }]
  })) : undefined, [imageUrl, theme.palette.grey, width.desktop, width.mobile]);
  if (!relativeUrl || !title) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Root, {
    className: className,
    "data-testid": getTestId(CATEGORY_BOX),
    href: relativeUrl,
    widthValues: width,
    children: [/*#__PURE__*/_jsxs(ImageWrapper, {
      heightValues: height,
      widthValues: width,
      children: [/*#__PURE__*/_jsx(LazyImage, {
        alt: title,
        sizes: `(max-width: ${theme.breakpoints.values.sm - 1}px) ${width.mobile}px, ${width.desktop}px`,
        srcSet: imagesVariants
      }), /*#__PURE__*/_jsx(ViewButtonWrapper, {
        children: /*#__PURE__*/_jsx(Button, {
          variant: "contained",
          color: "bannerButton",
          children: buttonText
        })
      })]
    }), description ? /*#__PURE__*/_jsx(Typography, {
      color: "textSecondary",
      children: description
    }) : null, /*#__PURE__*/_jsx(Typography, {
      variant: "subtitle1",
      component: "h6",
      textAlign: "center",
      color: "textPrimary",
      fontWeight: "bold",
      textTransform: "uppercase",
      children: title
    })]
  });
};
//# sourceMappingURL=CategoryBox.js.map